// Notifications dans l'application servies aux comptes usagers (portail citoyen, lot L1-B) :
// les lignes des canaux application et portail du compte, dans toutes les collectivités où il a
// un espace ou une représentation validée, chacune portant la collectivité qui l'a émise.
// Le marquage de lecture est idempotent : la première date de lecture est conservée.
import { z } from 'zod';
import { schemaFiltreNotifications } from './notifications-catalogue';

const uuid = z.string().uuid('Identifiant invalide');

/** GET /usager/notifications : mêmes paramètres que la route des agents (non_lues=oui, limite). */
export const schemaFiltreNotificationsUsager = schemaFiltreNotifications;

/** Canaux « table » lus par le portail : la ligne de notification est la remise elle-même. */
export const CANAUX_NOTIFICATION_USAGER = ['application', 'portail'] as const;

export const schemaNotificationUsager = z.object({
  id: uuid,
  evenement: z.string(),
  objet_type: z.string().nullable(),
  objet_id: uuid.nullable(),
  titre: z.string(),
  contenu: z.string(),
  canal: z.enum(CANAUX_NOTIFICATION_USAGER),
  /** Collectivité qui a émis la notification (le compte usager est national). */
  collectivite: z.object({ code: z.string(), nom: z.string() }),
  cree_le: z.string(),
  lue_le: z.string().nullable(),
});
export type NotificationUsager = z.infer<typeof schemaNotificationUsager>;

/** Réponse de GET /usager/notifications : les plus récentes d'abord, total des non lues toutes collectivités confondues. */
export const schemaListeNotificationsUsager = z.object({
  elements: z.array(schemaNotificationUsager),
  non_lues: z.number().int().min(0),
});
export type ListeNotificationsUsager = z.infer<typeof schemaListeNotificationsUsager>;

/** Réponse de POST /usager/notifications/:id/lue. */
export const schemaLectureNotificationUsager = z.object({ id: uuid, lue_le: z.string() });
export type LectureNotificationUsager = z.infer<typeof schemaLectureNotificationUsager>;
